import { object, string, number, boolean, lazy } from 'yup';

import { LoanProductRegValid } from '../util/mappings/loanProductRegValidations';
import errorText from './validationTexts';

export const euroTaxSchema = (
    loanAmountMin: number,
    loanAmountMax: number,
    shortMode: boolean,
    loanAmountErrorText: string,
    equityAmountErrorText: string,
    regValid: LoanProductRegValid,
    isCaravan: boolean,
) => {
    if (shortMode) {
        return object().shape({
            regNr: lazy((value) => {
                if (value !== undefined) {
                    return string()
                        .trim()
                        .min(regValid.min, errorText.regNoRequired)
                        .max(regValid.max, errorText.regNoRequired)
                        .matches(regValid.expression, errorText.regNoNotValid)
                        .typeError(errorText.regNoRequired)
                        .required(errorText.regNoRequired);
                }
                return string().notRequired();
            }),
        });
    }
    return object().shape({
        regNr: lazy((value) => {
            if (value !== undefined) {
                return string()
                    .trim()
                    .min(regValid.min, errorText.regNoRequired)
                    .max(regValid.max, errorText.regNoRequired)
                    .typeError(errorText.regNoRequired)
                    .matches(regValid.expression, errorText.regNoNotValid)
                    .required(errorText.regNoRequired);
            }
            return string().notRequired();
        }),

        equity: number()
            .moreThan(-1, errorText.equityNegative)
            .typeError(errorText.equityRequired)
            .required(errorText.equityRequired),

        vehiclePrice: number()
            .positive(errorText.vehiclePricePositive)
            .integer(errorText.vehiclePriceRequired)
            .typeError(errorText.vehiclePriceRequired)
            .required(errorText.vehiclePriceRequired)
            .test({
                name: 'vehiclePriceValidator',
                message: loanAmountErrorText,
                test(value: number) {
                    const { equity } = this.parent;
                    if (equity === undefined) {
                        return false;
                    }

                    return equity <= value - loanAmountMin && value <= equity + loanAmountMax;
                },
            }),

        loanPeriodInMonths: number().typeError(errorText.loanDurationRequired).required(errorText.loanDurationRequired),

        odometerValue: lazy((value) => {
            if (value !== undefined && !isCaravan) {
                return number()
                    .positive(errorText.odometerValuePositive)
                    .integer(errorText.odometerValueRequired)
                    .typeError(errorText.odometerValueRequired)
                    .required(errorText.odometerValueRequired);
            }
            return number().notRequired();
        }),

        manufacturer: lazy((value) => {
            if (value !== undefined) {
                return string().typeError(errorText.manufacturerRequired).required(errorText.manufacturerRequired);
            }
            return string().notRequired();
        }),

        model: lazy((value) => {
            if (value !== undefined) {
                return string().typeError(errorText.modelRequired).required(errorText.modelRequired);
            }
            return string().notRequired();
        }),

        modelYear: lazy((value) => {
            if (value !== undefined) {
                return number().typeError(errorText.modelYearRequired).required(errorText.modelYearRequired);
            }
            return number().notRequired();
        }),

        imported: boolean().notRequired(),
    });
};

export default { euroTaxSchema };
